import React from 'react';
import "./Om.css";
import AnimatedContent from "../../components/react-bits/AnimatedContent";

function Om() {
    return (
        <div className="container om-container">
            <h1>Om Sælv</h1>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <p>Find og del små lokale salgssteder – tillidsboder, gårdbutikker, genbrug og meget mere</p>
            </AnimatedContent>
            
            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <p>Sælv gør det nemt at opdage de små steder, hvor man kan købe alt fra æg og æbler til hjemmebag, genbrugsguld og håndlavet keramik. Det kan være en vejbod, en tillidsboks på et stakit, en genbrugsreol i en carport eller noget helt fjerde.</p>
            </AnimatedContent>
            
            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <p>Alt er crowdsourcet - det vil sige, at alle kan tilføje nye steder i appen. Du behøver ikke selv at eje en bod eller butik. Ser du noget, der mangler på kortet? Så tilføj det med et par klik, og hjælp andre med at finde det.</p>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <h3>Det kan du med Sælv:</h3>
                <ul>
                    <li>
                        Se lokale salgssteder på kortet - tæt på dig eller hvor du skal hen
                    </li>
                    <li>
                        Få detaljer om hvad der sælges, åbningstider og priser
                    </li>
                    <li>
                        Navigér direkte til stedet med rutevejledning
                    </li>
                    <li>
                        Betal med MobilePay, hvis sælgeren har MyShop
                    </li>
                    <li>
                        Finde genbrugsting og støtte lokale initiativer
                    </li>
                </ul>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <h3>Vil du selv dele noget?</h3>
            </AnimatedContent>
            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <p>Alle kan oprette en Sælv. Har du en overskudsbod, en lille tillidshylde eller nogle ting du vil af med, så opret et salgssted og gør det synligt for andre i nærheden. Det tager kun et øjeblik.</p>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <h3>Sælv er for dig, der...</h3>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <p>
                    ...hellere vil handle lokalt end i supermarkedet <br/>
                    ...elsker tanken om tillidshandel og genbrug <br/>
                    ...vil støtte dem, der deler deres overskud med nabolaget <br/>
                    ...måske bare har nogle squash i haven, du gerne vil af med <br/>
                </p>
            </AnimatedContent>

            <AnimatedContent
                distance={50}
                direction="vertical"
                reverse={false}
                duration={0.8}
                ease="easeInOut"
                initialOpacity={0}
                animateOpacity={true}
                scale={1.05}
                delay={0.1}
            >
                <h3>Gør det nemt at finde de små steder - og del dem med andre.</h3>
            </AnimatedContent>
        </div>
    );
}

export default Om;